import { Button, Flex } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TRY, useCreateCampaignStepsContext } from '../campaign-create-steps-context'
import { Title } from '../title'
import { Paragraph } from '../paragraph'
import { Chat } from '../../../../components/chat/chat'
import { FinishStep } from './finish-step'
import clsx from 'clsx'

import { ToolTestControls } from '../../../../app-connection/components/tool-test-controls'

function CreationToolTestControls() {
    const { toolTestMode, setToolTestMode, toolActivities, isSendingAssistantMessage, selectedType, formProps } =
        useCreateCampaignStepsContext()
    return selectedType === 'custom' && formProps.form.getFieldValue('tools')?.length ? (
        <ToolTestControls
            mode={toolTestMode}
            onChange={setToolTestMode}
            activities={toolActivities}
            disabled={isSendingAssistantMessage}
        />
    ) : null
}

export function TryStep() {
    const { t } = useTranslation()
    const { viewMatch, currentStep, tryOut, setTryOut, previousStep, nextStep, isSendingAssistantMessage, isPending } =
        useCreateCampaignStepsContext()

    if (viewMatch) {
        return <FinishStep />
    }

    if (tryOut) {
        return <PracticeTryStep />
    }

    return (
        <div className={clsx({ hidden: currentStep !== TRY })}>
            <Title>{t('Test conversation')}</Title>
            <CreationToolTestControls />
            <Paragraph>
                {t(
                    'Try the conversation as a candidate. You can adjust your settings afterward or continue without testing.'
                )}
            </Paragraph>
            <Flex
                justify="space-between"
                gap={12}
                wrap
            >
                <Button
                    size="large"
                    onClick={previousStep}
                >
                    {t('Back')}
                </Button>
                <Flex
                    gap="small"
                    wrap
                >
                    <Button
                        onClick={() => {
                            nextStep()
                        }}
                        loading={isSendingAssistantMessage || isPending}
                        size="large"
                    >
                        {t('Skip testing')}
                    </Button>
                    <Button
                        loading={isSendingAssistantMessage}
                        size="large"
                        type="primary"
                        onClick={() => {
                            setTryOut(true)
                        }}
                    >
                        {t('Start test conversation')}
                    </Button>
                </Flex>
            </Flex>
        </div>
    )
}

export function PracticeTryStep() {
    const { t } = useTranslation()
    const {
        currentStep,
        messages,
        sendAssistantMessage,
        setViewMatch,
        isSendingAssistantMessage,
        match,
        nextStep,
        previousStep,
    } = useCreateCampaignStepsContext()
    return (
        <div className={clsx({ hidden: currentStep !== TRY })}>
            <Title>{t('Test conversation')}</Title>
            <CreationToolTestControls />
            <Chat
                disabled={isSendingAssistantMessage}
                messages={messages}
                onMessageAdded={match ? undefined : sendAssistantMessage}
            />
            {match && (
                <Flex
                    justify="end"
                    className="w-full mt-4"
                >
                    <Button
                        size="large"
                        type="primary"
                        onClick={() => {
                            setViewMatch(true)
                        }}
                    >
                        {t('View score')}
                    </Button>
                </Flex>
            )}
            {!match && (
                <Flex
                    justify="space-between"
                    className="w-full mt-4"
                >
                    <Button
                        size="large"
                        onClick={previousStep}
                    >
                        {t('Back')}
                    </Button>
                    <Button
                        size="large"
                        type="primary"
                        onClick={nextStep}
                    >
                        {t('Continue')}
                    </Button>
                </Flex>
            )}
        </div>
    )
}
